import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

type UseUnsavedChangesWarningProps = {
  dirty: boolean;
  confirmLeave: boolean;
  targetLocation: any;
  setLeaveModalVisible: (value: boolean) => void;
  setDirty: any;
  setTargetLocation: any;
};

export const useUnsavedChangesWarning = ({
  dirty,
  confirmLeave,
  targetLocation,
  setLeaveModalVisible,
  setDirty,
  setTargetLocation
}: UseUnsavedChangesWarningProps) => {
  const history = useHistory();
  const unblock = useRef<null | (() => void)>(null);

  const proceed = () => {
    if (!targetLocation) return;

    if (unblock.current) {
      unblock.current();
    }
    history.push(targetLocation);
  };

  useEffect(() => {
    if (unblock.current) {
      unblock.current();
    }

    if (confirmLeave) {
      proceed();
      return;
    }

    setDirty(dirty);
    if (dirty) {
      unblock.current = history.block((location: any) => {
        setTargetLocation(location);
        setLeaveModalVisible(true);
        return false;
      });
    }

    return () => {
      if (unblock.current) {
        unblock.current();
      }
    };
  }, [history, confirmLeave, dirty]);

  return {
    proceed,
    cancelLeave: () => {
      setLeaveModalVisible(false);
      targetLocation.current = null;
    }
  };
};
